module.exports = __webpack_public_path__ + "static/media/firstmedia_logo.ffb62874.png";